export default function ({ $auth, redirect }) {
  if (!$auth || $auth.expirationTime * 1000 <= Date.now() || !$auth.user || $auth.user.role !== 'admin') {
    return redirect('/login')
  }
}